/**
 * Sort-dropdown options shared by the results table controllers.
 *
 * Extracted from `TableController` in WFW-6748 so the single-table controller
 * can offer the same sort choices without duplicating them. The host component
 * supplies `tableFields` (Array) and `usePillsLayout` (Boolean) as props.
 */

const SORT_OPTIONS = {
	alphaAscending: "alpha",
	alphaDescending: "-alpha",
	points: "score",
};

export default {
	computed: {
		hasScoreField() {
			return this.tableFields.includes("score") && !this.usePillsLayout;
		},
		filterOptions() {
			const options = {};

			if (this.hasScoreField) {
				options[SORT_OPTIONS.points] = {
					text: "ResultsSortPointsText",
					titleAttribute: this.$t("ResultsSortPointsTitleAttribute"),
					gaEventID: this.isWordListResultsPage ? 87 : 102,
					selected: this.pageOrderBy === SORT_OPTIONS.points,
					key: SORT_OPTIONS.points,
				};
			}

			options[SORT_OPTIONS.alphaAscending] = {
				text: "ResultsSortAlphabeticalText",
				titleAttribute: this.$t(
					"ResultsSortAlphabeticalTitleAttribute"
				),
				gaEventID: this.isWordListResultsPage ? 86 : 101,
				selected: this.pageOrderBy === SORT_OPTIONS.alphaAscending,
				key: SORT_OPTIONS.alphaAscending,
			};

			options[SORT_OPTIONS.alphaDescending] = {
				text: "ResultsSortInverseAlphabeticalText",
				titleAttribute: this.$t(
					"ResultsSortInverseAlphabeticalTitleAttribute"
				),
				gaEventID: this.isWordListResultsPage ? 88 : 103,
				selected: this.pageOrderBy === SORT_OPTIONS.alphaDescending,
				key: SORT_OPTIONS.alphaDescending,
			};

			return options;
		},
	},
};
